<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)" v-if="item">
		<el-page-header @back="goBack" content="售后信息"></el-page-header>
<table class="table" cellpadding="0" cellspacing="0">
			<tr>
				<th>订单号</th>
				<td>{{item.order_master.order_sn}}</td>
				<th>退款状态</th>
				<td colspan="3">
					<el-tag size="small" effect="dark" type="danger" v-if="item.status == 0">进行中</el-tag>
					<el-tag size="small" effect="dark" type="warning" v-else-if="item.status == 10">已拒绝</el-tag>
					<el-tag size="small" effect="dark" v-else-if="item.status == 20">已完成</el-tag>
					<el-tag size="small" effect="dark" type="warning" v-else-if="item.status == 30">已取消</el-tag>

				</td>
			</tr>
			<tr>
				<th>下单用户</th>
				<td>
					<div class="avatar" v-if="item.user">
						<img :src="item.user.avatar" />
						{{item.user.nick_name}}
					</div>
				</td>
				<th>收货人</th>
				<td>{{item.order_master.consignee}}</td>
				<th>手机号</th>
				<td colspan="3">{{item.order_master.mobile}}</td>
			</tr>
			<tr>
				<th>商品</th>
				<td>
					<div class="thumb">
						<img :src="item.order_goods.pic_url" />
						{{item.order_goods.product_name}}
					</div>
				</td>
				<th>规格</th>
				<td>
					{{item.order_goods.sku_name}}
				</td>
				<th>数量</th>
				<td>
					{{item.order_goods.number}} 件
				</td>
			</tr>
			<tr>
				<th>退款原因</th>
				<td colspan="5">{{item.apply_desc}}</td>
			</tr>
			<tr v-if="item.images.length">
				<th>退款凭证</th>
				<td colspan="5">
					<div class="el-images">
						<el-image :src="val" fit="cover" :preview-src-list="item.images" v-for="val in item.images"></el-image>
					</div>
				</td>
			</tr>
			<tr v-if="item.name || item.address || item.mobile">
				<th>退货地址</th>
				<td>{{item.address}}</td>
				<th>收货人</th>
				<td>{{item.name}}</td>
				<th>手机号</th>
				<td>{{item.mobile}}</td>
			</tr>
			<tr>
				<th>申请时间</th>
				<td>{{item.created_date}}</td>
				<th>订单金额</th>
				<td>{{item.order_goods.total_fee}} 元</td>
				<th>退款类型</th>
				<td>
					<template v-if="item.type == 1">
						仅退款
					</template>
					<template v-else-if="item.type == 2">
						退货退款
					</template>
				</td>
			</tr>
			<tr v-if="item.express_id">
				<th>退货时间</th>
				<td>{{item.send_time}}</td>
				<th>快递公司</th>
				<td>{{item.express}}</td>
				<th>快递单号</th>
				<td>{{item.express_no}}</td>
			</tr>
			<tr v-if="item.status == -1">
				<th>驳回时间</th>
				<td>{{item.fail_time}}</td>
				<th>驳回原因</th>
				<td colspan="3">{{item.reason}}</td>
			</tr>
			<tr v-else-if="item.status == 4">
				<th>退款时间</th>
				<td>{{item.refund_time}}</td>
				<th>退款金额</th>
				<td>
				    <el-link type="danger" :underline="false">{{item.refund_money}} 元</el-link>
				</td>
				<th>退款单号</th>
				<td>{{item.ordersn}}</td>
			</tr>
		</table>
<!--		<el-form ref="form" label-position="right" :model="param" label-width="auto" show-message inline-message status-icon v-if="item.status == 10 && item.arbitration_status == 10">-->
<!--			<el-form-item label="仲裁审核结果">-->
<!--				<el-radio-group v-model="param.arbitration_status">-->
<!--					<el-radio :label="1">通过</el-radio>-->
<!--					<el-radio :label="2">驳回</el-radio>-->
<!--				</el-radio-group>-->
<!--			</el-form-item>-->
<!--			<el-form-item>-->
<!--				<el-button type="primary" @click="submit">保存</el-button>-->
<!--			</el-form-item>-->
<!--		</el-form>-->
	</div>
</template>
<script>
export default {
	data() {
		return {
			item: null,
			param:{},
			isLoad: false,
			id: this.$route.query.id
		}
	},
	created() {
		this.loadData()
	},
	methods: {
		loadData() {
			this.isLoad = !this.isLoad
			this.axios.get('admin/order.refund/detail',{params:{
				id:this.id
			}}).then(res => {
				this.isLoad = !this.isLoad
				this.item = res.data.detail
				console.log(this.item)
				this.param.refund_money = this.item.order_goods.total_fee
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		goBack() {
			this.$router.back(-1)
		},
		submit() {
			this.isLoad = !this.isLoad
			let params = this.param

			this.axios.post('admin/order.refund/arbitrationAudit', {
				id: this.id,
				form: params
			}).then(res => {
				this.isLoad = !this.isLoad
				this.$message.success({
					message: '保存成功'
				});
				this.goBack()
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		handleReceipt() {
			this.isLoad = !this.isLoad
			let params = this.param
			this.axios.post('store/order.refund/receipt', {
				id: this.id,
				form: params
			}).then(res => {
				this.isLoad = !this.isLoad
				this.$message.success({
					message: '保存成功'
				});
				this.goBack()
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		}
	}
}
</script>
<style scoped>
.el-form{
	margin-top: 20px;
}
:deep().el-descriptions{
	margin-top: 20px;
}
.table{
	width: 100%;
	border-collapse: collapse;
	margin-top: 20px;
}
.table th{
	line-height: 1.5;
	background: #fafafa;
	color: #909399;
	font-weight: bold;
	text-align: center;
	border:1px solid #ebeef5;
	padding:12px 10px;
	width: 10%;
}
.table td{
	line-height: 1.5;
	color: #909399;
	border:1px solid #ebeef5;
	padding:12px 10px;
	color: #333;
	width: 10%;
}
.el-images{
	display: flex;
}
.el-images .el-image{
	height: 30px;
	margin-right: 10px;
}
</style>
